var initCarousel = function (options) {
    for (var i in options) {
        var option = options[i];
        var container = '#' + i;
        option.navText = [
            "<i class='fal icon-chevron-left'></i>",
            "<i class='fal icon-chevron-right'></i>"
        ];
        if ($(container).length > 0) {
            $(container).owlCarousel(option);
        }
    }

};

jQuery(document).ready(function($){
    var options = {
        mainSlider: {
            thumbs: false,
            thumbImage: false,
            items:1,
            margin:0,
            rtl:true,
            loop:true,
            nav:true,
            autoplay:true,
            autoplayTimeout:6000,
            dots:false,
            autoHeight:true
        },
        pageSlider: {
            thumbs: false,
            thumbImage: false,
            items:1,
            margin:0,
            rtl:true,
            loop:false,
            nav:true,
            mouseDrag: false,
            touchDrag: false,
            autoplay:false,
            autoplayTimeout:6000,
            dots:false,
            autoHeight:true
        }
    };
    initCarousel(options);
});

